import InfoWrapper from '../../../modules/common/SectionInfo'
import {
  configurationsSelector,
  updateConfigurationAction,
  updateNotificationState,
} from '../../../reducers/configurationReducer'
import {useDispatch, useSelector} from 'react-redux'
import {extractValues} from '../../../../util'
import {useEffect, useState} from 'react'
import {AppDispatch} from '../../../store'
import ConfModal from './modal/ConfModal'
import NotificationModal from './modal/NotificationModal'
import {KTSVG} from '../../../../_metronic/helpers'
// @ts-ignore
import Tooltip from 'react-bootstrap/Tooltip'
// @ts-ignore
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'

const InAppBannerHeader = () => (
  <div className='col-lg-2 col-form-label fw-bold fs-6'>
    In-App Banner
    <OverlayTrigger
      placement='top'
      overlay={
        <Tooltip id='in-app-banner-tooltip'>
          Controls whether this notification should show an in-app banner. Turn on if an in-app
          banner is needed, or leave off if it should not appear as an in-app banner.
        </Tooltip>
      }
    >
      <span
        style={{
          cursor: 'pointer',
          marginLeft: 6,
          marginTop: 2,
          display: 'inline-block',
          verticalAlign: 'text-top',
          lineHeight: 0,
        }}
      >
        <KTSVG
          path='/media/icons/duotune/general/gen045.svg'
          className='svg-icon-5 svg-icon-gray-500'
          svgClassName='w-15px h-15px'
        />
      </span>
    </OverlayTrigger>
  </div>
)

const NotificationConfigurations = ({state}: any) => {
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)
  const [activeTrigger, setActiveTrigger] = useState('client')
  const dispatch = useDispatch<AppDispatch>()

  const providerTriggers = extractValues(state?.value?.['provider-triggers'])
  const clientTriggers = extractValues(state?.value?.['client-triggers'])
  const [notification, setNotification] = useState<any>()
  // console.log('triggers', clientTriggers)

  const handleChange = (
    type: string,
    index: any,
    key: any,
    name: string,
    value: string | number
  ) => {
    if (type === 'client-triggers') {
      const updatedClientTriggers = [...state?.value?.['client-triggers']]
      let triggers = updatedClientTriggers
      triggers[index] = {
        ...triggers[index],
        [key]: {
          ...triggers[index][key],
          [name]: value,
        },
      }

      setNotification({
        ...notification,
        message: value,
      })

      // Update the state or perform any other necessary actions

      dispatch(updateNotificationState({data: triggers, name: 'client-triggers'}))

      // Update the state or perform any other necessary actions
    } else if (type === 'provider-triggers') {
      const updatedProviderTriggers = [...state?.value?.['provider-triggers']]

      let triggers = updatedProviderTriggers
      triggers[index] = {
        ...triggers[index],
        [key]: {
          ...triggers[index][key],
          [name]: value,
        },
      }

      // (prevData: any) => ({
      //   ...prevData,
      //   value: {
      //     ...prevData.value,
      //     'provider-triggers': triggers,
      //   },
      // })

      // Update the state or perform any other necessary actions
      dispatch(updateNotificationState({data: triggers, name: 'provider-triggers'}))

      // console.log('triggers', triggers)
      // console.log('data', data?.value)
    }
  }

  return (
    <div className='card' id='kt_profile_details_view'>
      <div className='card-body px-9 py-2'>
        <div className='d-flex overflow-auto h-55px'>
          <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap w-100'>
            <li className='nav-item w-50 d-flex justify-content-center'>
              <div
                className={`nav-link text-active-primary me-6 pointer w-100 ${
                  activeTrigger === 'client' ? 'active' : ''
                }`}
                onClick={() => setActiveTrigger('client')}
              >
                Client Triggers
              </div>
            </li>
            <li className='nav-item w-50 d-flex'>
              <div
                className={`nav-link text-active-primary me-6 pointer w-100 ${
                  activeTrigger === 'provider' ? 'active' : ''
                }`}
                onClick={() => setActiveTrigger('provider')}
              >
                Provider Triggers
              </div>
            </li>
          </ul>
        </div>
        <div className='mt-4'>
          {activeTrigger === 'client' ? (
            <InfoWrapper title=''>
              <div className='row'>
                <div className='col-12'>
                  <div className='row'>
                    <div className='col-lg-3 col-form-label fw-bold fs-6'>Events</div>
                    <div className='col-lg-2 col-form-label fw-bold fs-6'>Status</div>
                    <InAppBannerHeader />
                    <div className='col-lg-5 col-form-label fw-bold fs-6'>Sample Message</div>
                  </div>
                  {clientTriggers?.map((data: any, idx: number) => (
                    <div
                      className={`row py-2 ${
                        idx + 1 !== clientTriggers?.length && 'border-bottom'
                      }`}
                      key={data?.key}
                    >
                      <div
                        className='col-lg-3'
                        style={{
                          wordBreak: 'break-word',
                        }}
                      >
                        <label className='col-form-label fw-bold fs-6'>
                          <span>{data?.key}</span>
                        </label>
                      </div>
                      <div className='col-lg-2'>
                        <div className='d-flex'>
                          <div className='form-check form-check form-switch fv-row'>
                            <input
                              className={`form-check-input w-45px h-30px`}
                              type='checkbox'
                              name='is_active'
                              onChange={(e) =>
                                handleChange(
                                  'client-triggers',
                                  idx,
                                  data?.key,
                                  e.target.name,
                                  e.target.checked ? 1 : 0
                                )
                              }
                              checked={data?.is_active === 1 ? true : false}
                              id={`client-is-active-${idx}`}
                            />
                            <label className='form-check-label'></label>
                          </div>
                        </div>
                      </div>
                      <div className='col-lg-2'>
                        <div className='d-flex'>
                          <div className='form-check form-check form-switch fv-row'>
                            <input
                              className={`form-check-input w-45px h-30px`}
                              type='checkbox'
                              name='in_app_notification'
                              onChange={(e) =>
                                handleChange(
                                  'client-triggers',
                                  idx,
                                  data?.key,
                                  e.target.name,
                                  e.target.checked ? 1 : 0
                                )
                              }
                              checked={data?.in_app_notification === 1 ? true : false}
                              id={`client-in-app-${idx}`}
                            />
                            <label className='form-check-label'></label>
                          </div>
                        </div>
                      </div>
                      <div className='col-lg-5 pb-2'>
                        <div className='d-flex'>
                          <textarea
                            className='form-control'
                            name='message'
                            cols={3}
                            style={{
                              resize: 'none',
                            }}
                            disabled
                            value={data?.message}
                          />
                        </div>
                        <div
                          className='text-end mt-1'
                          onClick={() => {
                            handleOpen()
                            setNotification({
                              ...data,
                              type: 'client-triggers',
                              idx: idx,
                            })
                          }}
                        >
                          <div className='p-2'>
                            <KTSVG
                              path={'/media/icons/duotune/general/gen055.svg'}
                              className='svg-icon-2 border p-2 pointer bg-light'
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </InfoWrapper>
          ) : (
            <InfoWrapper title=''>
              <div className='row'>
                <div className='col-12'>
                  <div className='row'>
                    <div className='col-lg-3 col-form-label fw-bold fs-6'>Events</div>
                    <div className='col-lg-2 col-form-label fw-bold fs-6'>Status</div>
                    <InAppBannerHeader />
                    <div className='col-lg-5 col-form-label fw-bold fs-6'>Sample Message</div>
                  </div>
                  {providerTriggers?.map((data: any, idx: number) => (
                    <div
                      className={`row py-2 ${
                        idx + 1 !== providerTriggers?.length && 'border-bottom'
                      }`}
                      key={data?.key}
                    >
                      <div
                        className='col-lg-3'
                        style={{
                          wordBreak: 'break-word',
                        }}
                      >
                        <label className='col-form-label fw-bold fs-6'>
                          <span>{data?.key}</span>
                        </label>
                      </div>
                      <div className='col-lg-2'>
                        <div className='d-flex'>
                          <div className='form-check form-check form-switch fv-row'>
                            <input
                              className={`form-check-input w-45px h-30px`}
                              type='checkbox'
                              name='is_active'
                              checked={data?.is_active === 1 ? true : false}
                              onChange={(e) =>
                                handleChange(
                                  'provider-triggers',
                                  idx,
                                  data?.key,
                                  e.target.name,
                                  e.target.checked ? 1 : 0
                                )
                              }
                              id={`provider-is-active-${idx}`}
                            />
                            <label className='form-check-label'></label>
                          </div>
                        </div>
                      </div>
                      <div className='col-lg-2'>
                        <div className='d-flex'>
                          <div className='form-check form-check form-switch fv-row'>
                            <input
                              className={`form-check-input w-45px h-30px`}
                              type='checkbox'
                              name='in_app_notification'
                              checked={data?.in_app_notification === 1 ? true : false}
                              onChange={(e) =>
                                handleChange(
                                  'provider-triggers',
                                  idx,
                                  data?.key,
                                  e.target.name,
                                  e.target.checked ? 1 : 0
                                )
                              }
                              id={`provider-in-app-${idx}`}
                            />
                            <label className='form-check-label'></label>
                          </div>
                        </div>
                      </div>
                      <div className='col-lg-5 pb-2'>
                        <div className='d-flex'>
                          <textarea
                            className='form-control'
                            name='message'
                            disabled
                            value={data?.message}
                            cols={3}
                            style={{
                              resize: 'none',
                            }}
                          />
                        </div>
                        <div
                          className='text-end mt-1'
                          onClick={() => {
                            handleOpen()
                            setNotification({
                              ...data,
                              type: 'provider-triggers',
                              idx: idx,
                            })
                          }}
                        >
                          <div className='p-2'>
                            <KTSVG
                              path={'/media/icons/duotune/general/gen055.svg'}
                              className='svg-icon-2 border p-2 pointer bg-light'
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </InfoWrapper>
          )}
          <div className='d-flex justify-content-end py-6'>
            <NotificationModal
              open={open}
              handleClose={handleClose}
              handleChange={handleChange}
              data={notification}
              setData={setNotification}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default NotificationConfigurations
